<template>
  <div class="as-item">
    <div class="as-item-block">
      <div class="item-image">
        <router-link :to="'/' + locale + '/items/' + el.id">
          <img :src="el.images[0]" />
        </router-link>
      </div>
      <div class="item-body text-center">
        <div class="name">
          <router-link
            :to="'/' + locale + '/items/' + el.id"
            style="display:block;"
          >
            <span v-if="el.name[locale]">{{ el.name[locale] }}</span>
            <span v-else>{{ el.exposhoes_id }}</span>
          </router-link>
        </div>
        <div class="brand">
          <span class="badge badge-secondary">{{ el.trademark }}</span>
        </div>
        <div class="price text-center">
          <span>{{ el.price }} грн.</span>
        </div>
        <button class="btn btn-outline-primary mobile-vis">
          <font-awesome-icon class="as-icon" :icon="['far', 'star']" />
        </button>
      </div>
      <div class="item-footer">
        <div class="size-chart mobile-hidden">
          <ul>
            <li
              v-for="(size, index) in el.sizes"
              :key="index"
              @click.prevent="addToCart(el, size)"
            >
              <span>{{ getSizes(size) }}</span>
            </li>
          </ul>
        </div>
        <!-- <div class="flex">
          <button class="btn btn-primary" v-on:click.prevent="addToCart(el)">
            <font-awesome-icon icon="cart-plus" />
          </button>
          <button class="btn btn-outline-primary">
            <font-awesome-icon class="as-icon" :icon="['far', 'star']" />
            <font-awesome-icon class="as-icon" :icon="['fas', 'star']" />
          </button>
        </div> -->
      </div>
    </div>
    <b-modal
      class="modal-info"
      ref="modalInfo"
      size="xl"
      lazy
      hide-footer
      title="Добавление в корзину"
    >
      <InfoModal />
    </b-modal>
  </div>
</template>
<script>
import InfoModal from "@/components/modals/InfoAddToCart.vue";
export default {
  props: ["el"],
  data() {
    return {
      locale: this.$route.params.locale
    };
  },
  methods: {
    getSizes(size) {
      let allSizes = this.$store.state.GlobalData.sizes;
      for (let i = 0; i < allSizes.length; i++) {
        if (size.size === allSizes[i].id) {
          return allSizes[i].name[this.locale];
        }
      }
    },
    addToCart(itemToAdd, size) {
      let sizes = this.$store.state.GlobalData.sizes;

      itemToAdd.size = sizes.find(f => f.id === size.size);
      itemToAdd.quantity = 1;
      this.$store.commit("addToCart", itemToAdd);
      this.$refs.modalInfo.show();
    }
  },
  components: {
    InfoModal
  }
};
</script>
